"use strict";

(function () {
  var wizard = document.getElementById("gasWizard");
  var form = document.getElementById("gasWizardForm");
  if (!wizard || !form) return;

  var currentStep = 1;
  var isSubmitting = false;
  var steps = Array.prototype.slice.call(form.querySelectorAll("[data-step]"));
  var maxStep = steps.reduce(function (max, step) {
    return Math.max(max, Number(step.getAttribute("data-step")) || 0);
  }, 1);
  var progressItems = Array.prototype.slice.call(
    wizard.querySelectorAll("[data-progress]")
  );
  var propertyInputs = Array.prototype.slice.call(
    form.querySelectorAll('input[name="物件種別"]')
  );
  var occupancyField = document.getElementById("occupancyTypeField");
  var occupancyInputs = Array.prototype.slice.call(
    form.querySelectorAll('input[name="お立場"]')
  );
  var postcodeInput = document.getElementById("gasPostcode");
  var confirmList = document.getElementById("gasWizardConfirm");
  var detailInput = document.getElementById("gasWizardDetail");
  var residenceTypeInput = document.getElementById("gasResidenceType");
  var fullNameInput = form.querySelector('input[name="お名前"]');

  function getCheckedValue(name) {
    var checked = form.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : "";
  }

  function getValue(name) {
    var input = form.elements[name];
    if (!input) return "";
    if (input instanceof RadioNodeList) return input.value || "";
    return String(input.value || "").trim();
  }

  function normalizeDigits(value) {
    return String(value || "")
      .replace(/[０-９]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 65248);
      })
      .replace(/\D/g, "");
  }

  function normalizeKatakana(value) {
    var text = String(value || "");
    return typeof text.normalize === "function" ? text.normalize("NFKC") : text;
  }

  function isFullWidthKatakana(value) {
    return !value || /^[ァ-ヶー・　 ]+$/.test(value);
  }

  function isValidTelephone(value) {
    var text = String(value || "").trim();
    var digits = normalizeDigits(text);
    var withoutHyphens = /^0[0-9]{9,10}$/.test(text);
    var withHyphens = /^0[0-9]{1,4}-[0-9]{1,4}-[0-9]{4}$/.test(text);
    return (
      (digits.length === 10 || digits.length === 11) &&
      (withoutHyphens || withHyphens)
    );
  }

  function setError(name, message, input) {
    var error = form.querySelector('[data-error-for="' + name + '"]');
    if (error) error.textContent = message || "";
    if (input) {
      if (message) {
        input.setAttribute("aria-invalid", "true");
      } else {
        input.removeAttribute("aria-invalid");
      }
    }
  }

  function clearStepErrors(step) {
    step.querySelectorAll(".p-gasWizard__error").forEach(function (error) {
      error.textContent = "";
    });
    step.querySelectorAll('[aria-invalid="true"]').forEach(function (input) {
      input.removeAttribute("aria-invalid");
    });
  }

  function validateStep(stepNumber) {
    var valid = true;
    var firstInvalid = null;
    var step = form.querySelector('[data-step="' + stepNumber + '"]');
    if (!step) return true;
    clearStepErrors(step);

    if (step.querySelector('input[name="物件種別"]')) {
      if (!getCheckedValue("物件種別")) {
        setError("物件種別", "物件種別を選択してください。");
        firstInvalid = form.querySelector('input[name="物件種別"]');
        valid = false;
      }
      if (
        getCheckedValue("物件種別") === "マンション・アパート" &&
        !getCheckedValue("お立場")
      ) {
        setError("お立場", "お立場を選択してください。");
        firstInvalid = firstInvalid || form.querySelector('input[name="お立場"]');
        valid = false;
      }
    }

    if (step.querySelector('input[name="利用場所"]') && !getCheckedValue("利用場所")) {
      setError("利用場所", "ガスを利用する場所を選択してください。");
      firstInvalid = firstInvalid || form.querySelector('input[name="利用場所"]');
      valid = false;
    }

    if (step.querySelector("#gasPostcode")) {
      if (!/^\d{3}-\d{4}$/.test(postcodeInput.value)) {
        setError("郵便番号", "郵便番号は「123-4567」の形式で入力してください。", postcodeInput);
        firstInvalid = postcodeInput;
        valid = false;
      }
    }

    if (step.querySelector('input[name="姓"]')) {
      var familyName = form.elements["姓"];
      var givenName = form.elements["名"];
      if (!familyName.value.trim() || !givenName.value.trim()) {
        setError("お名前", "姓と名を入力してください。", !familyName.value.trim() ? familyName : givenName);
        firstInvalid = !familyName.value.trim() ? familyName : givenName;
        valid = false;
      }

      var furiganaFamily = form.elements["せい"];
      var furiganaGiven = form.elements["めい"];
      furiganaFamily.value = normalizeKatakana(furiganaFamily.value.trim());
      furiganaGiven.value = normalizeKatakana(furiganaGiven.value.trim());
      var hasFurigana = furiganaFamily.value || furiganaGiven.value;
      if (
        hasFurigana &&
        (!furiganaFamily.value ||
          !furiganaGiven.value ||
          !isFullWidthKatakana(furiganaFamily.value) ||
          !isFullWidthKatakana(furiganaGiven.value))
      ) {
        setError("フリガナ", "姓と名を全角カタカナで入力してください。", furiganaFamily);
        firstInvalid = firstInvalid || furiganaFamily;
        valid = false;
      }

      var telInput = form.elements["電話番号"];
      telInput.value = telInput.value.trim();
      if (!isValidTelephone(telInput.value)) {
        setError(
          "電話番号",
          "電話番号は半角数字10〜11桁で入力してください。ハイフンはあってもなくても構いません。",
          telInput
        );
        firstInvalid = firstInvalid || telInput;
        valid = false;
      }

      var emailInput = form.elements["Email"];
      emailInput.value = emailInput.value.trim();
      if (!emailInput.validity.valid) {
        setError(
          "メールアドレス",
          "正しいメールアドレスを入力してください。",
          emailInput
        );
        firstInvalid = firstInvalid || emailInput;
        valid = false;
      }

      var consentInput = form.querySelector('input[name="個人情報の取扱いへの同意"]');
      if (!consentInput.checked) {
        setError("個人情報の取扱いへの同意", "個人情報保護方針への同意が必要です。");
        firstInvalid = firstInvalid || consentInput;
        valid = false;
      }
    }

    if (!valid && firstInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return valid;
  }

  function showStep(stepNumber) {
    currentStep = Math.max(1, Math.min(maxStep, stepNumber));
    steps.forEach(function (step) {
      var active = Number(step.getAttribute("data-step")) === currentStep;
      step.hidden = !active;
      step.classList.toggle("is-active", active);
    });
    progressItems.forEach(function (item) {
      var number = Number(item.getAttribute("data-progress"));
      item.classList.toggle("is-current", number === currentStep);
      item.classList.toggle("is-done", number < currentStep);
      if (number === currentStep) {
        item.setAttribute("aria-current", "step");
      } else {
        item.removeAttribute("aria-current");
      }
    });
    wizard.scrollIntoView({ behavior: "smooth", block: "start" });
    var heading = form.querySelector('[data-step="' + currentStep + '"] h2');
    if (heading) {
      heading.setAttribute("tabindex", "-1");
      window.setTimeout(function () {
        heading.focus({ preventScroll: true });
      }, 350);
    }
  }

  function updatePropertyConditional() {
    var isApartment = getCheckedValue("物件種別") === "マンション・アパート";
    occupancyField.hidden = !isApartment;
    occupancyInputs.forEach(function (input) {
      input.required = isApartment;
      if (!isApartment) input.checked = false;
    });
    if (!isApartment) setError("お立場", "");
  }

  function formatPostcode() {
    var digits = normalizeDigits(postcodeInput.value).slice(0, 7);
    postcodeInput.value =
      digits.length > 3 ? digits.slice(0, 3) + "-" + digits.slice(3) : digits;
    if (postcodeInput.value) setError("郵便番号", "", postcodeInput);
  }

  function appendConfirmRow(label, value) {
    var row = document.createElement("div");
    var term = document.createElement("dt");
    var description = document.createElement("dd");
    term.textContent = label;
    description.textContent = value || "—";
    row.appendChild(term);
    row.appendChild(description);
    confirmList.appendChild(row);
  }

  function prepareSubmissionValues() {
    var fullName = getValue("姓") + " " + getValue("名");
    fullNameInput.value = fullName.trim();
    residenceTypeInput.value = getCheckedValue("お立場") || "持ち家";
    var furigana = (getValue("せい") + " " + getValue("めい")).trim();
    detailInput.value = [
      "物件種別：" + getCheckedValue("物件種別"),
      getCheckedValue("お立場") ? "お立場：" + getCheckedValue("お立場") : "",
      "住居区分：" + residenceTypeInput.value,
      getCheckedValue("利用場所") ? "利用場所：" + getCheckedValue("利用場所") : "",
      getValue("現在ご利用のガス会社")
        ? "現在ご利用のガス会社：" + getValue("現在ご利用のガス会社")
        : "",
      "郵便番号：" + getValue("郵便番号"),
      "お名前：" + fullNameInput.value,
      furigana ? "フリガナ：" + furigana : "",
      "電話番号：" + getValue("電話番号"),
      "メールアドレス：" + getValue("Email"),
    ]
      .filter(Boolean)
      .join("\n");
  }

  function buildConfirmation() {
    prepareSubmissionValues();
    confirmList.textContent = "";
    appendConfirmRow("物件種別", getCheckedValue("物件種別"));
    if (getCheckedValue("お立場")) appendConfirmRow("お立場", getCheckedValue("お立場"));
    appendConfirmRow("住居区分", residenceTypeInput.value);
    if (getCheckedValue("利用場所")) {
      appendConfirmRow("ガスを利用する場所", getCheckedValue("利用場所"));
    }
    if (getValue("現在ご利用のガス会社")) {
      appendConfirmRow("現在ご利用のガス会社", getValue("現在ご利用のガス会社"));
    }
    appendConfirmRow("郵便番号", getValue("郵便番号"));
    appendConfirmRow("お名前", fullNameInput.value);
    appendConfirmRow("フリガナ", (getValue("せい") + " " + getValue("めい")).trim());
    appendConfirmRow("電話番号", getValue("電話番号"));
    appendConfirmRow("メールアドレス", getValue("Email"));
  }

  propertyInputs.forEach(function (input) {
    input.addEventListener("change", updatePropertyConditional);
  });

  form.querySelectorAll("[data-next]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (!validateStep(currentStep)) return;
      if (currentStep === 4) buildConfirmation();
      showStep(currentStep + 1);
    });
  });

  form.querySelectorAll("[data-back]").forEach(function (button) {
    button.addEventListener("click", function () {
      showStep(currentStep - 1);
    });
  });

  postcodeInput.addEventListener("input", formatPostcode);

  ["せい", "めい"].forEach(function (name) {
    var input = form.elements[name];
    input.addEventListener("blur", function () {
      input.value = normalizeKatakana(input.value.trim());
      var family = form.elements["せい"].value;
      var given = form.elements["めい"].value;
      if (
        (family || given) &&
        ((!family || isFullWidthKatakana(family)) && (!given || isFullWidthKatakana(given)))
      ) {
        setError("フリガナ", "");
      } else if (!isFullWidthKatakana(input.value)) {
        setError("フリガナ", "全角カタカナで入力してください。", input);
      }
    });
  });

  form.elements["電話番号"].addEventListener("blur", function () {
    var input = form.elements["電話番号"];
    input.value = input.value.trim();
    if (isValidTelephone(input.value)) {
      setError("電話番号", "", input);
    }
  });

  form.elements["Email"].addEventListener("blur", function () {
    var input = form.elements["Email"];
    input.value = input.value.trim();
    setError(
      "メールアドレス",
      input.validity.valid ? "" : "正しいメールアドレスを入力してください。",
      input
    );
  });

  form.addEventListener("submit", function (event) {
    if (currentStep !== maxStep || isSubmitting) {
      event.preventDefault();
      return;
    }
    for (var stepNumber = 1; stepNumber < maxStep; stepNumber += 1) {
      if (!validateStep(stepNumber)) {
        event.preventDefault();
        showStep(stepNumber);
        return;
      }
    }
    prepareSubmissionValues();
    isSubmitting = true;
    var submitButton = form.querySelector(".p-gasWizard__submit");
    submitButton.disabled = true;
    submitButton.textContent = "送信中…";
  });

  var gasCompanyInput = form.elements["現在ご利用のガス会社"];
  if (gasCompanyInput) {
    gasCompanyInput.addEventListener("input", prepareSubmissionValues);
  }

  updatePropertyConditional();
  showStep(1);
})();
